import React from 'react'
import { Tooltip, Popconfirm } from 'antd'
import AddIcon from 'react-icons/lib/md/add-circle-outline'
import CachedIcon from 'react-icons/lib/md/cached'
import ErrorIcon from 'react-icons/lib/md/error-outline'

import * as API from './api'
import { log, showMessage } from '../../config/utils'
import { UPDATE_MODEL_ACCURACY_STATE } from './actiontypes'
import { PAGE_LOADING, PAGE_LOADED } from '../page_details/actiontypes'
import { startPageLoading, stopPageLoading } from '../page_details/actions'
import { store } from '../../../index'

export const updateModelState = payload => ({
  type: UPDATE_MODEL_ACCURACY_STATE,
  payload
})

export const getAccuracyFilters = () => dispatch => {
  dispatch({
    type: PAGE_LOADING,
    payload: "Loading filters"
  })
  API.getAccuracyFilters({}, (error, response) => {
    log('get accuracy filters response:', response)
    dispatch({ type: PAGE_LOADED })
    if (!error && response) {
      const payload = {
        source_filters: response
      }
      dispatch(updateModelState(payload))
    } else
      showMessage('error', 'Error loading the filters, please refresh the page')
  })
}

const makeApiCall = (url, method, data, btnId) => {
  store.dispatch(startPageLoading())
  API.makeApiCall(url, method, data, (error, response) => {
    log('action button api call response', response)
    store.dispatch(stopPageLoading())
    if (!error && response) {
      showMessage('success', response.message ? response.message : 'Completed successfully')
      document.getElementById(`${btnId}`).style.pointerEvents = 'none'
    }
    else
      showMessage('error', response.message ? response.message : 'Some error occured')
  })
}

export const getIntentsTableData = data => dispatch => {
  dispatch({ type: PAGE_LOADING, payload: "Loading data" })
  API.getIntentsTableData(data, (error, response) => {
    log('get intents table data response:', response)
    dispatch({ type: PAGE_LOADED })
    if (!error && response && response.correct_intents && response.columns) {
      response.columns.forEach(col => {
        if (col.dataIndex && col.dataIndex === 'actions') {
          // eslint-disable-next-line react/display-name
          col.render = buttons => (
            <div className='ori-flex-row ori-flex-jc'>
              {
                buttons.map(btnData => {
                  const { id, endpoint, method, payload, text } = btnData
                  return (
                    <Popconfirm
                      key={btnData.id}
                      placement="topLeft"
                      title="Are you sure?"
                      okText="Yes"
                      cancelText="No"
                      onConfirm={makeApiCall.bind(null, endpoint, method, payload, id)}
                    >
                      <Tooltip title={text}>
                        <div id={`${id}`} className="ori-pad-5 ori-flex-column ori-flex-jc ori-cursor-ptr ori-r-mrgn-5 ori-font-light-hover-primary" >
                          {text === 'Add to Intent' ? <AddIcon size={16} /> : (btnData === 'Add to Cache' ? <CachedIcon size={16} /> : <ErrorIcon size={16} />)}
                        </div>
                      </Tooltip>
                    </Popconfirm>
                  )
                })}
            </div>
          )
        }
      })
      const payload = {
        correct_intents: response.correct_intents,
        table_columns: response.columns,
        intents_load_error: false,
        count_data: response.CountData
      }
      dispatch(updateModelState(payload))
    } else
      dispatch(updateModelState({ intents_load_error: true }))
  })
}




// WEBPACK FOOTER //
// ./src/data/redux/model_accuracy_details/actions.js